import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
// import numeral from 'numeral';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

// Actions
import { gameActions } from '../../actions';

import { Modal, ModalBody } from 'reactstrap';
import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';
import List from '../../components/List';
import PlayerDetails from '../../components/PlayerDetails';

const Leaderboard = (props) => {
  const [selectedPlayer, setSelectedPlayer] = useState(null);

  // Hooks
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const { id } = useParams();

  // Effects
  useEffect(() => {
    if (id) {
      dispatch(gameActions.fetchGames(id));
    }
  }, [dispatch, id]);

  const rowClick = (data) => {
    setSelectedPlayer(data);
  };

  // PLAYER DATA
  // {
  //   "EventType": "end_of_day",
  //   "LocalTimeStamp": "2025-06-05T18:24:46.868-04:00",
  //   "Data": {
  //       "Day": 1,
  //       "CompletedTasks": [
  //           "Take a nap."
  //       ],
  //       "ActiveTasks": [],
  //       "AbandonedTasks": [],
  //       "Points": {
  //           "Skills": 0,
  //           "Context": 0,
  //           "Wellness": 18,
  //           "Teamwork": 0
  //       },
  //       "GameLog": {
  //           "08_00": "Take a nap.",
  //           "10_00": "Take a nap.",
  //           "12_00": "Take a nap.",
  //           "14_00": "Take a nap.",
  //           "16_00": "Take a nap.",
  //           "18_00": "Take a nap.",
  //           "20_00": "Take a nap."
  //       }
  //   },
  //   "Duration": 0
  // }

  const playersData = game.data.players?.map((player) => {
    // Player end of day data
    const endOfDayResult = player?.results?.find(
      (r) => r.EventType === 'end_of_day',
    );
    const playerGameLog = endOfDayResult?.Data?.GameLog;
    const playerPoints = endOfDayResult?.Data?.Points;

    // Part 2 (Epilogue) results
    const part2_Day1_Result = player?.results?.find(
      (r) =>
        r.EventType === 'quest_state_change' &&
        r.Data?.questName?.startsWith('(Day 1)'),
    );
    const part2_Day45_Result = player?.results?.find(
      (r) =>
        r.EventType === 'quest_state_change' &&
        r.Data?.questName?.startsWith('(Day 45)'),
    );

    return {
      name: player?.name || '',
      surname: player?.lastname || '',
      email: player?.email || '',
      skillsPoints: playerPoints?.Skills || 0,
      contextPoints: playerPoints?.Context || 0,
      wellnessPoints: playerPoints?.Wellness || 0,
      teamworkPoints: playerPoints?.Teamwork || 0,
      // Total Points
      totalPoints: playerPoints
        ? Object.values(playerPoints).reduce((a, b) => a + b, 0)
        : 0,
      day1Decision: part2_Day1_Result
        ? part2_Day1_Result.Data?.questName
        : 'N/A',
      day45Decision: part2_Day45_Result
        ? part2_Day45_Result.Data?.questName
        : 'N/A',
      actionsButtons: (
        <div>
          <button
            className='btn btn-outline-primary btn-sm'
            onClick={() =>
              rowClick({
                ...player,
                playerPoints: playerPoints,
                gameLog: playerGameLog,
                day1Decision: part2_Day1_Result
                  ? part2_Day1_Result.Data?.questName
                  : 'N/A',
                day45Decision: part2_Day45_Result
                  ? part2_Day45_Result.Data?.questName
                  : 'N/A',
              })
            }>
            Details
          </button>
        </div>
      ),
    };
  });

  return (
    <div>
      <Header />

      <h2 className='mt-3 sec-title fs-3'>
        Leaderboard
        <small className='float-end'>
          <DebriefMenu game_id={game.data._id} location={props.location} />
        </small>
      </h2>

      <div style={{ fontSize: '14px' }}>
        <List
          labels={[
            'Name',
            'Surname',
            'Email',
            'Skills Points',
            'Context Points',
            'Wellness Points',
            'Teamwork Points',
            'Total Points',
            'Day 1 Decision',
            'Day 45 Decision',
            'Actions',
          ]}
          fields={[
            'name',
            'surname',
            'email',
            'skillsPoints',
            'contextPoints',
            'wellnessPoints',
            'teamworkPoints',
            'totalPoints',
            'day1Decision',
            'day45Decision',
            'actionsButtons',
          ]}
          sortables={[
            'name',
            'surname',
            'email',
            'skillsPoints',
            'contextPoints',
            'wellnessPoints',
            'teamworkPoints',
            'totalPoints',
            'day1Decision',
            'day45Decision',
            'actionsButtons',
          ]}
          data={playersData}
          // onRowClick={rowClick}
        />
      </div>

      <Modal
        isOpen={selectedPlayer ? true : false}
        centered={true}
        size='xl'
        trapFocus={true}
        toggle={() => setSelectedPlayer(null)}>
        <ModalBody className='text-center'>
          <FontAwesomeIcon
            icon={faTimesCircle}
            size='2x'
            className='icon bg-white text-danger'
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              cursor: 'pointer',
              borderRadius: '50%',
            }}
            onClick={() => setSelectedPlayer(null)}
          />
          {selectedPlayer && <PlayerDetails player={selectedPlayer} />}
        </ModalBody>
      </Modal>
    </div>
  );
};

export { Leaderboard as GameLeaderboard };
